import { j as p } from "./jsx-runtime-CZlWR0BA.js";
import { useRef as _, useEffect as I, useState as x } from "react";
import { B as $ } from "./button-DhWQ-ElG.js";
import { H as C, C as y } from "./styled-components.browser.esm-CdvvWRMU.js";
import { u as E } from "./useDebounceCallback-f50z_p0T.js";
const k = (n, e) => {
  const t = _(!0);
  I(() => {
    if (t.current)
      t.current = !1;
    else
      return n();
  }, e);
};
var g = /* @__PURE__ */ ((n) => (n.KEYBOARD = "keyboard", n.MOUSE = "mouse", n))(g || {});
const D = /\D/, A = (n, e, t) => {
  n === "" && t(e);
}, V = (n) => {
  const { onInputChange: e, inputValue: t, maxPossibleSaleQty: c, minimumSaleQuantity: i, quantity: l, setInputValue: r, isLoading: o } = n, d = t === "" ? t : ((u) => u < i && u > 0 ? i : u > c ? c : u)(+t).toString();
  r(d), +d !== l && d !== "" && !o && e(+d);
}, F = (n) => {
  const {
    onInputChange: e,
    inputValue: t,
    isLoading: c,
    maxPossibleSaleQty: i,
    minimumSaleQuantity: l = 1,
    quantity: r,
    setInputValue: o,
    setInteractionOrigin: s
  } = n;
  return { onChange: (a) => {
    D.test(a.target.value) || o(a.target.value.replace(D, ""));
  }, onBlur: () => {
    A(t, r.toString(), o);
  }, onInputClick: (a) => {
    a.stopPropagation();
  }, onDecrementClick: (a) => {
    a.stopPropagation(), s(g.MOUSE), +t === l ? o("0") : o((+t - 1).toString());
  }, onIncrementClick: (a) => {
    a.stopPropagation(), s(g.MOUSE), o((+t + 1).toString());
  }, onKeyDown: (a) => {
    s(g.KEYBOARD), a.key === "Enter" && (t === "" ? o("0") : V({
      inputValue: t,
      isLoading: c,
      maxPossibleSaleQty: i,
      minimumSaleQuantity: l,
      onInputChange: e,
      quantity: r,
      setInputValue: o
    }));
  }, onFirstAddButtonClick: (a) => {
    a.stopPropagation(), s(g.MOUSE), o(l.toString());
  } };
}, K = (n) => {
  const { active: e, expandCounter: t, inputValue: c, quantity: i, variant: l } = n, [r, o] = x(!1), s = l === "simplified";
  return I(() => {
    o((i >= 1 || +c >= 1) && !s && e);
  }, [e, c, s, i]), I(() => {
    t && t(r);
  }, [t, r]), { isCounterExpanded: r };
}, T = 800, q = 300, z = 5e3, H = (n) => {
  const {
    clickingDelay: e,
    inputValue: t,
    interactionOrigin: c,
    isLoading: i,
    maxPossibleSaleQty: l,
    minimumSaleQuantity: r = 1,
    onInputChange: o,
    quantity: s,
    setInputValue: d,
    typingDelay: u
  } = n;
  E(
    () => {
      A(t, s.toString(), d);
    },
    z,
    [t]
  ), E(
    () => V({
      onInputChange: o,
      inputValue: t,
      maxPossibleSaleQty: l,
      minimumSaleQuantity: r,
      quantity: s,
      setInputValue: d,
      isLoading: i
    }),
    c === g.KEYBOARD ? u : e,
    [t]
  );
}, B = (n, e, t) => {
  if (e)
    return t === "lg" ? n.spacingInlineLgRem : t === "md" ? n.spacingInlineMdRem : n.spacingInlineSmRem;
  if (!e)
    return t === "lg" ? "17.5rem" : t === "md" ? "14rem" : "9.5rem";
}, O = (n, e) => e === "lg" ? n.spacingInlineLgRem : e === "md" ? n.spacingInlineMdRem : n.spacingInlineSmRem, G = C.div`
  display: flex;
  justify-content: flex-end;
  padding: ${(n) => n.variant === "horizontal" ? "0" : n.theme.spacingStackNanoRem};
`, W = C.div`
  display: flex;
  min-width: auto;
  align-items: center;
`, P = C($)`
  height: ${(n) => O(n.theme, n.size)};
  width: ${(n) => B(n.theme, !0, n.size)};
`, X = C.input`
  outline: none;
  text-align: center;
  font-size: 1.2rem;
  border: ${(n) => n.theme.borderWidthHairline} solid ${(n) => n.theme.colorNeutralDarkest};
  font-family: ${(n) => n.theme.fontFamilyLight};
  padding: ${(n) => n.theme.spacingInlineQuarck};
  border-radius: ${(n) => n.theme.spacingInlineNano};
  margin: 0 ${(n) => n.theme.spacingInlineNanoRem};
  line-height: ${(n) => n.theme.lineHeightTight};
  background-color: ${(n) => n.theme.colorNeutralLightest};
  height: 100%;
  ${({ inputSize: n, theme: e }) => n === "lg" ? y`
        width: 4.9rem;
      ` : n === "md" ? y`
        width: 3.75rem;
      ` : y`
      width: 3.7rem;
      font-size: ${e.fontSizeXxxs};
    `}
`, J = C($)`
  &::before {
    position: relative;
    right: 0;
  }
  height: ${(n) => O(n.theme, n.size)};
  width: ${(n) => B(n.theme, n.isIconOnly, n.size)};
  display: ${(n) => n.hidden ? "none" : "flex"};
  justify-content: center;
`, Z = (n) => {
  const {
    active: e = !0,
    clickingDelay: t = q,
    expandCounter: c = () => {
    },
    isLoading: i,
    label: l,
    maxPossibleSaleQty: r,
    minimumSaleQuantity: o = 1,
    onAbort: s,
    onInputChange: d,
    quantity: u = 0,
    size: f = "sm",
    typingDelay: S = T,
    variant: h = "default",
    ...b
  } = n, [m, a] = x(u.toString()), [R, v] = x(g.MOUSE);
  H({
    clickingDelay: t,
    inputValue: m,
    interactionOrigin: R,
    isLoading: i,
    maxPossibleSaleQty: r,
    minimumSaleQuantity: o,
    onInputChange: d,
    quantity: u,
    setInputValue: a,
    typingDelay: S
  });
  const { isCounterExpanded: L } = K({ active: e, quantity: u, inputValue: m, variant: h, expandCounter: c }), { onChange: N, onBlur: j, onDecrementClick: M, onIncrementClick: U, onKeyDown: w, onFirstAddButtonClick: Q, onInputClick: Y } = F({
    isLoading: i,
    inputValue: m,
    maxPossibleSaleQty: r,
    minimumSaleQuantity: o,
    onInputChange: d,
    quantity: u,
    setInputValue: a,
    setInteractionOrigin: v
  });
  return k(() => {
    i || a(u.toString());
  }, [i, u]), k(
    () => () => {
      s && s();
    },
    [m]
  ), /* @__PURE__ */ p.jsx(G, { variant: h, ...b, children: L ? /* @__PURE__ */ p.jsxs(W, { "aria-label": "Contador completo", children: [
    /* @__PURE__ */ p.jsx(
      P,
      {
        "aria-label": "Disminuir cantidad",
        variant: "secondary",
        onClick: M,
        size: f,
        iconName: +m === o ? "trash" : "minus",
        disabled: +m <= 0 || i,
        isLoading: i,
        isIconOnly: !0
      }
    ),
    /* @__PURE__ */ p.jsx(
      X,
      {
        "aria-label": "Caja de texto",
        value: m,
        onBlur: j,
        onChange: N,
        disabled: i,
        type: "tel",
        inputSize: f,
        onKeyDown: w,
        onClick: Y
      }
    ),
    /* @__PURE__ */ p.jsx(
      P,
      {
        "aria-label": "Aumentar cantidad",
        variant: "primary",
        onClick: U,
        size: f,
        iconName: "plus",
        isLoading: i,
        disabled: +m <= 0 || i || +m === r,
        isIconOnly: !0
      }
    )
  ] }) : /* @__PURE__ */ p.jsx(
    J,
    {
      hidden: !e,
      "aria-label": "Botón de añadir",
      variant: "primary",
      hasIcon: l ? "left" : void 0,
      iconName: "plus",
      onClick: Q,
      isLoading: i,
      size: f,
      disabled: !e,
      isIconOnly: !l,
      children: l
    }
  ) });
}, rn = Z;
export {
  rn as P
};
